import { Routes } from '@angular/router';
import { BrowsercheckGuard } from './core/browsercheck.guard';
import { TranslateModule } from '@ngx-translate/core';
import { importProvidersFrom } from '@angular/core';
import { AuthenticationGuard } from './core/authentication/authentication.guard';
import { Route } from './core/route.service';

export const routes: Routes = Route.withShell([
  {
    path: '',
    // canActivate: [BrowsercheckGuard],
    children: [
      {
        path: '',
        loadComponent: () => {
          return import('./admin-page/admin-page.component').then(
            (m) => m.AdminPageComponent
          );
        },
        //canActivate: [AuthenticationGuard],
      },
      // {
      //   path: '',
      //   loadComponent: () => {
      //     return import('./admin-boot/admin-boot.component').then(
      //       (m) => m.AdminBootComponent
      //     );
      //   },
      //   //  canActivate: [AuthenticationGuard],
      // },
      {
        path: 'reload/:url',
        loadComponent: () => {
          return import('./reload/reload.component').then(
            (m) => m.ReloadComponent
          );
        },
        //canActivate: [AuthenticationGuard],
      },
      {
        path: 'admin-page',
        loadComponent: () => {
          return import('./admin-page/admin-page.component').then(
            (m) => m.AdminPageComponent
          );
        },
        //canActivate: [AuthenticationGuard],
      },
      {
        path: 'access-config/:subscriptionId/:randomId',
        loadComponent: () => {
          return import('./access-config/access-config.component').then(
            (m) => m.AccessConfigComponent
          );
        },
      },
      {
        path: 'ana-desktop',
        loadComponent: () => {
          return import(
            './access-config/ana-desktop/ana-desktop.component'
          ).then((m) => m.AnaDesktopComponent);
        },
        //canActivate: [AuthenticationGuard],
      },
      {
        path: 'user-desktop',
        loadComponent: () => {
          return import(
            './access-config/user-desktop/user-desktop.component'
          ).then((m) => m.UserDesktopComponent);
        },
        // canActivate: [AuthenticationGuard],
      },
      {
        path: 'single-user-config/:subscriptionId/:randomId',
        loadComponent: () => {
          return import(
            './access-config/single-user-config/single-user-config.component'
          ).then((m) => m.SingleUserConfigComponent);
        },
      },
      {
        path: 'admin-notifications',
        loadComponent: () => {
          return import(
            './admin-notifications/admin-notifications.component'
          ).then((m) => m.AdminNotificationsComponent);
        },
        //  canActivate: [AuthenticationGuard],
      },
      {
        path: 'admin-popups',
        loadComponent: () => {
          return import(
            './admin-popups/admin-popups.component'
          ).then((m) => m.AdminPopupsComponent);
        },
        //  canActivate: [AuthenticationGuard],
      },
      {
        path: 'admin-users',
        loadComponent: () => {
          return import('./admin-users/admin-users.component').then(
            (m) => m.AdminUsersComponent
          );
        },
        // canActivate: [AuthenticationGuard],
      },
      {
        path: 'admin-move-docs',
        loadComponent: () => {
          return import('./admin-move-docs/admin-move-docs.component').then(
            (m) => m.AdminMoveDocsComponent
          );
        },
        // canActivate: [AuthenticationGuard],
      },
      {
        path: 'manage-accesses/:subscriptionId',
        loadComponent: () => {
          return import('./access-config/common/manage-accesses/manage-accesses.component').then(
            (m) => m.ManageAccessesComponent
          );
        },
      },
      {
        path: 'admin-stats',
        loadComponent: () => {
          return import('./admin-stats/admin-stats.component').then(
            (m) => m.AdminStatsComponent
          );
        },
        // canActivate: [AuthenticationGuard],
      },
    ],
  },
]);
